import React, { useState } from 'react';
import { connect } from "react-redux";
import { useNavigate, useLocation } from 'react-router-dom';

export default class BaseController extends React.Component {

		constructor(props) {
			super(props);
		}
}